import React, { useEffect, useState } from 'react';

import lang from '../../lang/lang';

import Button from '../UI/Button/Button';

import { ModalBackgroundStyled, ModalStyled, ModalBackgroundClickedStyled, ModalWindowStyled, CloseWrapperStyled, MainStyled, MainStyledText, MainStyledActions, Close, MainStyledTitle } from './Modal.styled';

const Modal = (props) => {
    const {open} = props;
    const {closeBtn} = props;
    const [langState, setLangState] = useState(localStorage.getItem('language') || 'en')

    
    const confirm = () => {
        props.onConfirm();
        props.onClose();
    }

    return open ? <>
    <ModalStyled>
        <ModalBackgroundStyled></ModalBackgroundStyled>
        <ModalBackgroundClickedStyled onClick={props.onClose}></ModalBackgroundClickedStyled>
            <ModalWindowStyled>
                    {
                        closeBtn ? <CloseWrapperStyled>
                        <Close onClick={props.onClose}>
                            <span className='icon-cancel-circle'></span>
                        </Close>
                    </CloseWrapperStyled> : null
                    }
                    <MainStyled>
                        <MainStyledText>
                            <span>{props.text}</span>
                        </MainStyledText>
                        <MainStyledTitle>
                            <span>{props.title}</span>
                        </MainStyledTitle>
                        <MainStyledActions>
                            <Button 
                                success
                                text={langState === 'uk' ? lang.uk.yes : lang.en.yes}
                                onClick={confirm}
                            />
                            <Button 
                                danger
                                text={langState === 'uk' ? lang.uk.no : lang.en.no}
                                onClick={props.onClose}
                            />
                        </MainStyledActions>
                    </MainStyled>
            </ModalWindowStyled>
    </ModalStyled>
</> : null;
}

export default Modal;